module.exports = __webpack_public_path__ + "img/w3_package_black.6f1216a4.png";